package com.essntl.features.crm.ui

import com.essntl.core.utils.utils.loadingmanager.LoadingManager
import com.essntl.core.utils.viewmodel.ViewModel
import com.essntl.core.utils.viewmodel.getData
import com.essntl.features.crm.domain.repository.CRMRepository
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Job
import kotlinx.coroutines.delay
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class CRMViewModel(
    private val crmRepository: CRMRepository,
    private val state: MutableStateFlow<CRMState>,
    override val scope: CoroutineScope,
    override val loadingManager: LoadingManager,
) : ViewModel {

    fun onEvent(event: CRMEvent) {
        when (event) {
            is CRMEvent.GetOrganizationList -> getOrganizationList(event)
            is CRMEvent.Toggle -> toggle(event)
        }
    }

    fun toggle(event: CRMEvent.Toggle) {
        state.update {
            it.copy(
                selectedContactTab = event.index,
            )
        }.also {
            if (event.index == 0)
                getOrganizationList(CRMEvent.GetOrganizationList("travel_agency", state.value.searchText))
            else if (event.index == 1)
                getOrganizationList(CRMEvent.GetOrganizationList("supplier", state.value.searchText))
        }
    }

    private var getOrganizationsJob: Job? = null
    fun getOrganizationList(event: CRMEvent.GetOrganizationList) {
        getOrganizationsJob?.cancel()
        getOrganizationsJob = scope.launch {
            state.update {
                it.copy(
                    searchText = event.searchText,
                )
            }

            if (event.delay)
                delay(500)

            getData(
                getData = {
                    crmRepository.getOrganizationList(
                        event.type,
                        state.value.searchText,
                    )
                },
                getState = { state.value.getOrganizationList },
                setState = { newState -> state.update { it.copy(getOrganizationList = newState) } },
            )
        }
    }
}